import type { IconSvgObject } from './types';

const MinimizeScreenIcon: IconSvgObject = [
  ["path", { d: "M2 9.125L2.00032 3.99988C2.00039 2.89536 2.89581 2 4.00033 2.00001L20 2.00009C21.1046 2.0001 22 2.89553 22 4.00009V18.9732C22 20.074 21.1105 20.9678 20.0098 20.9732L14.5174 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 3L14 10M13.5 6.5V10.5H17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 15.5V14C2 13.4477 2.44772 13 3 13H4.5M8.5 13H10C10.5523 13 11 13.4477 11 14V15.5M11 19.5V21C11 21.5523 10.5523 22 10 22H8.5M4.5 22H3C2.44772 22 2 21.5523 2 21V19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MinimizeScreenIcon;
